$(function () {
    if (!$('#gcv-comisiones-producto').length) {
        return;
    }
    var H = GcvComisionesHelper;
    H.init({
        tableSelector: '#gcvComisionesProductoTable',
        filterSelector: '#gcvComisionesProductoFilter',
        searchButton: '#gcvComisionesProductoBuscar',
        exportButton: '#gcvComisionesProductoExportar',
        exportUrl: HOST + '/comisiones/producto/export',
        dataUrl: HOST + '/comisiones/producto/data',
        queryType: 'producto',
        useUrlPagination: true,
        order: [[0, 'DESC']],
        totalesFields: ['comision_empleado_producto', 'comision_empleado_producto_prevista', 'comision_empleado_producto_max_prevista'],
        columns: [
            {data: 'periodo', title: 'PERIODO', className: 'uk-text-center'},
            {data: 'comisionista', title: 'COMISIONISTA', className: 'uk-text-center'},
            {data: 'empleado', title: 'EMPLEADO', className: 'uk-text-center'},
            {data: 'denominacion_comision_producto', title: 'DENOMINACIÓN COMISIÓN PRODUCTO', className: 'uk-text-center'},
            {data: 'denominacion_producto', title: 'DENOMINACIÓN PRODUCTO', className: 'uk-text-left'},
            H.pctUmbralViabilidadCol('mult_umb_via_aplicado', '% UMB. VIAB.'),
            H.decimalCol('pct_stock_obsoleto', '% STOCK OBS.'),
            H.decimalCol('pto_exc_total', 'PTO EXC.'),
            H.decimalCol('mult_umb_via_aplicado', 'MULT. VIAB.'),
            H.decimalCol('mult_umb_via_max', 'MULT. VIAB. MÁX.'),
            H.decimalCol('mult_pto_exc_aplicado', 'MULT. EXC.'),
            H.decimalCol('mult_pto_exc_max', 'MULT. EXC. MÁX.'),
            H.decimalCol('comision_empleado_producto', 'COM. EMPLEADO PRODUCTO', true),
            H.decimalCol('pct_umbral_viabilidad_previsto', '% UMB. VIAB. PREV.'),
            H.decimalCol('mult_umb_via_previsto', 'MULT. VIAB. PREV.'),
            H.decimalCol('comision_empleado_producto_prevista', 'COM. EMPLEADO PRODUCTO PREV.', true),
            H.decimalCol('comision_empleado_producto_max_prevista', 'COM. EMPLEADO PRODUCTO PREV. MÁX.', true)
        ]
    });
});
